import React from 'react';
import { motion } from 'framer-motion';
import { Play, RotateCcw, ArrowRight, ShieldAlert, Zap, X } from 'lucide-react';
import VideoPlayer from '../../features/pro-module/components/VideoPlayer';

const TacticalOverlay = ({ type, data, onContinue, onRetry }) => {
  // type: 'briefing' | 'intervention'
  const isIntervention = type === 'intervention';

  return (
    <div className="fixed inset-0 z-[100] bg-slate-950/95 backdrop-blur-md overflow-y-auto">
      <div className="min-h-screen flex flex-col items-center justify-center p-4">
        
        <motion.div 
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="w-full max-w-md bg-slate-900 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl relative my-8"
        >
          {/* HEADER: HANDLER STATUS */}
          <div className={`p-4 flex items-center gap-3 border-b ${isIntervention ? 'bg-red-900/20 border-red-500/30' : 'bg-cyan-900/20 border-cyan-500/30'}`}>
            <div className={`p-2 rounded-lg ${isIntervention ? 'bg-red-500 text-white' : 'bg-cyan-500 text-slate-900'}`}>
              {isIntervention ? <ShieldAlert size={20} /> : <Zap size={20} />}
            </div>
            <div>
              <h3 className={`font-black uppercase tracking-widest text-sm ${isIntervention ? 'text-red-400' : 'text-cyan-400'}`}>
                {isIntervention ? 'Mission Failure' : 'Incoming Intel'}
              </h3>
              <p className="text-xs text-slate-400 font-mono">
                {isIntervention ? 'Tactical Intervention Required' : 'Pre-Game Briefing'}
              </p>
            </div>
          </div>

          {/* CONTENT BODY */}
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-2 leading-tight text-white">{data.title}</h2>
            
            {/* THE INTEL SCRIPT (Your "Host" Text) */}
            <div className="mb-6 p-4 bg-black/40 rounded-xl border-l-2 border-slate-600 text-sm text-slate-300 italic font-medium leading-relaxed">
              "{data.script}"
            </div>

            {/* VERTICAL VIDEO CONTAINER */}
            <div className="w-full bg-black rounded-xl overflow-hidden relative shadow-inner border border-slate-800 mb-6 group">
               <VideoPlayer 
                  videoUrl={data.videoUrl} 
                  videoText={data.title}
                  videoIndex={0}
                  totalVideos={1}
                  onNext={() => {}} 
                  onPrev={() => {}}
                  aspectRatio="aspect-[9/16]" // Force Vertical Ratio for Intel
               />
               {/* Overlay for "Vertical" feel if using placeholder */}
               <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-black/20 via-transparent to-black/60" />
            </div>

            {/* ACTIONS */}
            {isIntervention ? (
              <button 
                onClick={onRetry}
                className="w-full py-4 bg-emerald-600 hover:bg-emerald-500 text-white font-black uppercase tracking-wider rounded-xl shadow-lg flex items-center justify-center gap-2 transition-all hover:scale-[1.02]"
              >
                <RotateCcw size={18} /> Retry with Intel
              </button>
            ) : (
              <button 
                onClick={onContinue}
                className="w-full py-4 bg-cyan-600 hover:bg-cyan-500 text-white font-black uppercase tracking-wider rounded-xl shadow-lg flex items-center justify-center gap-2 transition-all hover:scale-[1.02]"
              >
                Start Mission <ArrowRight size={18} />
              </button>
            )}
          </div>

        </motion.div>
      </div>
    </div>
  );
};

export default TacticalOverlay;